































import Vue from "vue";
import { reactive } from "@vue/composition-api";
import { ThirdPartyModal } from "./thirdParty.modal";
export default Vue.extend({
  setup() {
    const third_party_popups = reactive({
      is_show: false,
      width: "10rem",
      height: "10rem",
      link: ""
    });
    ThirdPartyModal.setRootCmp(({ height, width, link }) => {
      third_party_popups.link = link;
      third_party_popups.width = width;
      third_party_popups.height = height;
      third_party_popups.is_show = true;
    });
    return {
      third_party_popups
    };
  }
});
